import {Component, Input, OnInit, Optional} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {AutoUnsubscribe} from 'src/infrastructure/decorators/auto-unsubscribe.decorator';
import {Subscription} from 'rxjs';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {HsProcessingFilter} from '../../models/hs-process.component';
import {HsProcessingService} from '../../services/hs-processing.service';
import {DynamicAutocompleteItem} from '../../../shared/service/dynamic-autocomplete/dynamic-autocomplete.service';

@AutoUnsubscribe()
@Component({
    selector: 'hs-processing-filter',
    templateUrl: './hs-processing-filter.component.html',
    standalone: false
})
export class HsProcessingFilterComponent implements OnInit {
    @Input() config!:HsProcessingFilter;

    hsProcessingFilterForm!:FormGroup;
    adxReferenceControl = new FormControl<DynamicAutocompleteItem | null>(null);
    hsTicketNumberControl = new FormControl<DynamicAutocompleteItem | null>(null);

    breakPoint$?:Subscription;
    isSmall: boolean = false;
    constructor(
        @Optional() public matchingDialogRef: MatDialogRef<HsProcessingFilterComponent>,
        private formBuilder:FormBuilder,
        private hsProcessingService: HsProcessingService,
        breakpointObserver: BreakpointObserver,
    ){
        this.hsProcessingFilterForm = this.formBuilder.group({
            dateCreatedFrom: null,
            dateCreatedTo: null,
            adxReference: this.adxReferenceControl,
            hsTicketNumber: this.hsTicketNumberControl,
            invalid: null,
        });

        this.breakPoint$ = breakpointObserver.observe([
            Breakpoints.Medium,
            Breakpoints.Small,
            Breakpoints.XSmall
        ]).subscribe(result => {
            this.isSmall = result.matches;
        });
        
     }

    ngOnInit(): void {
        this.hsProcessingService.getHsProcessingFilter().subscribe((filter: HsProcessingFilter) => {
            this.config = filter;
            
            // Handle autocomplete field restoration
            if (filter) {
                if (filter.adxReference && typeof filter.adxReference === 'string') {
                    this.adxReferenceControl.setValue({
                        value: filter.adxReference,
                        originalValue: filter.adxReference
                    });
                }
                
                if (filter.hsTicketNumber && typeof filter.hsTicketNumber === 'string') {
                    this.hsTicketNumberControl.setValue({
                        value: filter.hsTicketNumber,
                        originalValue: filter.hsTicketNumber
                    });
                }
                
                // Patch other fields but exclude the autocomplete fields we just handled
                const { adxReference, hsTicketNumber, ...otherFields } = filter;
                this.hsProcessingFilterForm.patchValue(otherFields);
            } else {
                this.hsProcessingFilterForm.patchValue(this.config || {});
            }
        });
    }

    applyMatchingFilters(){
        this.config = this.hsProcessingFilterForm.value;
        
        if (typeof this.config.adxReference === 'object' && this.config.adxReference !== null) {
            this.config.adxReference = (this.config.adxReference as any).value || (this.config.adxReference as any).toString();
        }
        this.config.adxReference = this.config.adxReference?.trim();
        
        if (typeof this.config.hsTicketNumber === 'object' && this.config.hsTicketNumber !== null) {
            this.config.hsTicketNumber = (this.config.hsTicketNumber as any).value || (this.config.hsTicketNumber as any).toString();
        }
        this.config.hsTicketNumber = this.config.hsTicketNumber?.trim();
        
        this.hsProcessingService.setHsProcessingFilter(this.config);
        this.matchingDialogRef.close(this.config);
    }

    handleBookingFiltersFormCloseEvent() {
        if (this.matchingDialogRef) {
          this.matchingDialogRef.close();
        }
    }

    clearMatchingFields(...args:string[]){
        if(!args.length) {
            this.hsProcessingFilterForm.reset();
            return;
        }
        args.forEach((field)=>{
            this.hsProcessingFilterForm.controls[field].reset()
        })
    }
}
